// Touch

/*

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}

*/


// Menu hover
/*
if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details:not(.shop-by-brand):not(.links)");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 100);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}
*/

// Menu Expand

/*
document.querySelectorAll(".header__submenu > li").forEach(function(element){
  element.addEventListener("click", function(event){

    document.querySelectorAll(".header__submenu > li details").forEach(function(element){
      element.removeAttribute("open");
    });

  });
});

body.addEventListener("click", function(event){
  document.querySelectorAll(".header__submenu > li details").forEach(function(element){
    element.removeAttribute("open");
  });
});
*/


/*
document.addEventListener('keydown', function (e){
  if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I') || (e.ctrlKey && e.key === 'U')){

    e.preventDefault();

  }
});

document.addEventListener('contextmenu', e => e.preventDefault());
*/


// Close Facets

document.addEventListener('change', (e) => {
  if (e.target.matches('.facets__list input')) {

    // Only act if the option is being selected (not deselected)
    if (e.target.checked) {
      setTimeout(() => {
        const dropdown = e.target.closest('details');
        if (dropdown) {
          dropdown.removeAttribute('open');
        }
      }, 500);
    }

  }
});


// Add to cart button
/*
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[name="add"]');
  if (!btn) return;

  const textEl = btn.querySelector('span') || btn;

  const observer = new MutationObserver(() => {
    const isLoading = btn.classList.contains('loading') || btn.disabled;

    if (!isLoading) {
      observer.disconnect();

      // Store whatever Shopify JUST set (fresh state)
      const freshText = textEl.textContent;

      // Show "Added"
      textEl.textContent = 'Added';

      setTimeout(() => {
        // Only revert if button still exists
        if (document.body.contains(btn)) {
          textEl.textContent = freshText;
        }
      }, 1500);
    }
  });

  observer.observe(btn, {
    attributes: true,
    childList: true,
    subtree: true
  });
});
*/

// Disable all add-to-cart buttons while one product is adding
/*
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[name="add"]');
  if (!btn) return;

  const allButtons = [...document.querySelectorAll('[name="add"]')];
  const textEl = btn.querySelector('span') || btn;

  // Disable ALL other add-to-cart buttons
  allButtons.forEach((b) => {
    if (b !== btn) {
      b.disabled = true;
      b.classList.add('is-temp-disabled');
    }
  });

  const observer = new MutationObserver(() => {
    const isLoading =
      btn.classList.contains('loading') || btn.disabled;

    // Wait until Shopify finishes adding
    if (!isLoading) {
      observer.disconnect();

      // Re-enable other buttons
      allButtons.forEach((b) => {
        if (b !== btn && b.classList.contains('is-temp-disabled')) {
          setTimeout(() => {
            b.disabled = false;
            b.classList.remove('is-temp-disabled');
          }, 2500);
        }
      });

      // Store whatever Shopify JUST set
      const freshText = textEl.textContent;

      // Show "Added"
      textEl.textContent = 'Added';

      setTimeout(() => {
        if (document.body.contains(btn)) {
          textEl.textContent = freshText;
        }
      }, 1500);
    }
  });

  observer.observe(btn, {
    attributes: true,
    childList: true,
    subtree: true
  });
});
*/

// Add to cart button -- NEW
/*
document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[name="add"]');
  if (!btn) return;

  const productForm = btn.closest('product-form');
  if (!productForm) return;

  const form = productForm.querySelector('form');
  if (!form) return;

  const variantId = form.querySelector('input[name="id"]')?.value;

  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || '1', 10);

  if (!variantId) return;

  e.preventDefault();

  queueAddToCart(variantId, quantity, btn);
});

let cartQueue = [];
let processingQueue = false;

function queueAddToCart(variantId, quantity = 1, btn) {
  cartQueue.push({ variantId, quantity, btn });

  if (!processingQueue) {
    processQueue();
  }
}

function delay(ms) {
  return new Promise(res => setTimeout(res, ms));
}

async function processQueue() {
  if (processingQueue) return;
  processingQueue = true;

  while (cartQueue.length > 0) {
    const { variantId, quantity, btn } = cartQueue.shift();

    const form = btn.closest('form');

    const textEl = btn.querySelector('span') || btn;
    const originalText = textEl.textContent;

    // Disable ALL quick add buttons
    const allButtons = document.querySelectorAll('button[name="add"]');
    allButtons.forEach(b => {
      b.disabled = true;
      b.classList.add('is-temp-disabled');
    });

    textEl.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity
        })
      });

      if (res.status === 429) {
        console.warn('429 detected — retrying');
        cartQueue.unshift({ variantId, quantity, btn });
        await delay(1000);
        continue;
      }

      if (!res.ok) throw new Error(`Add failed: ${res.status}`);

      await res.json();

      textEl.textContent = 'Added';

      await delay(800);

      await refreshCartBubble();

    } catch (err) {
      console.error(err);
      textEl.textContent = 'Error';
      await delay(800);
    }

    // Re-enable buttons
    allButtons.forEach(b => {
      b.disabled = false;
      b.classList.remove('is-temp-disabled');
    });

    textEl.textContent = originalText;

    await delay(200);
  }

  processingQueue = false;
}

async function refreshCartBubble() {
  const cart = await fetch('/cart.js').then(r => r.json());

  const bubble = document.querySelector('.cart-count-bubble');

  if (!bubble) return;

  const count = cart.item_count;

  bubble.innerHTML = count > 0 ? `
    <span aria-hidden="true">${count}</span>
    <span class="visually-hidden">${count} items</span>
  ` : '';

  document.querySelector('.cart-count-bubble').style.display = 'block';
}
*/

/*
// ------------------------------
// Add to Cart (Production Safe Queue)
// ------------------------------

document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[name="add"]');
  if (!btn) return;

  const productForm = btn.closest('product-form');
  if (!productForm) return;

  const form = productForm.querySelector('form');
  if (!form) return;

  const variantId = form.querySelector('input[name="id"]')?.value;
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || '1', 10);

  if (!variantId) return;

  e.preventDefault();
  queueAddToCart(variantId, quantity, btn);
});

let cartQueue = [];
let processingQueue = false;

// ⛔ GLOBAL THROTTLE STATE
let throttleUntil = 0;

const delay = (ms) => new Promise(r => setTimeout(r, ms));

function queueAddToCart(variantId, quantity = 1, btn) {
  cartQueue.push({ variantId, quantity, btn });
  if (!processingQueue) processQueue();
}

function disableAllButtons() {
  document.querySelectorAll('button[name="add"]').forEach(b => {
    b.disabled = true;
    b.classList.add('is-temp-disabled');
  });
}

function enableAllButtons() {
  document.querySelectorAll('button[name="add"]').forEach(b => {
    b.disabled = false;
    b.classList.remove('is-temp-disabled');
  });
}

// ------------------------------
// MAIN QUEUE PROCESSOR
// ------------------------------
async function processQueue() {
  if (processingQueue) return;
  processingQueue = true;

  while (cartQueue.length > 0) {

    // ⛔ If we're in cooldown, wait
    if (Date.now() < throttleUntil) {
      const wait = throttleUntil - Date.now();
      console.warn(`Throttled. Waiting ${Math.ceil(wait / 1000)}s`);
      await delay(wait);
    }

    const { variantId, quantity, btn } = cartQueue.shift();

    const textEl = btn.querySelector('span') || btn;
    const originalText = textEl.textContent;

    disableAllButtons();
    textEl.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity
        })
      });

      const contentType = res.headers.get('content-type') || '';

      // 🚨 Cloudflare HTML block detection
      if (contentType.includes('text/html')) {
        console.warn('Cloudflare challenge detected. Stopping queue.');

        alert('Security check detected. Please refresh the page to continue.');
        break;
      }

      // 🚨 Rate limit handling (429)
      if (res.status === 429) {
        console.warn('429 detected → entering cooldown mode');

        // push item back
        cartQueue.unshift({ variantId, quantity, btn });

        // stop spam requests for 60 seconds
        throttleUntil = Date.now() + 60000;

        await delay(1000);
        continue;
      }

      if (!res.ok) throw new Error(`Add failed: ${res.status}`);

      await res.json();

      textEl.textContent = 'Added';
      await delay(700);

      await refreshCartBubble();

    } catch (err) {
      console.error(err);
      textEl.textContent = 'Error';
      await delay(700);
    }

    enableAllButtons();
    textEl.textContent = originalText;

    await delay(200);
  }

  processingQueue = false;
}

// ------------------------------
// CART BUBBLE UPDATE
// ------------------------------
async function refreshCartBubble() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const count = cart.item_count;

    bubble.innerHTML = count > 0
      ? `
        <span aria-hidden="true">${count}</span>
        <span class="visually-hidden">${count} items</span>
      `
      : '';

    bubble.style.display = 'block';

  } catch (err) {
    console.error('Cart refresh failed:', err);
  }
}
*/
// ------------------------------
// Add to Cart (Clean Production Queue)
// ------------------------------
/*
document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[name="add"]');
  if (!btn) return;

  const productForm = btn.closest('product-form');
  if (!productForm) return;

  const form = productForm.querySelector('form');
  if (!form) return;

  const variantId = form.querySelector('input[name="id"]')?.value;
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || '1', 10);

  if (!variantId) return;

  e.preventDefault();
  queueAddToCart(variantId, quantity, btn);
});

let cartQueue = [];
let processingQueue = false;

const delay = (ms) => new Promise(r => setTimeout(r, ms));

function queueAddToCart(variantId, quantity = 1, btn) {
  cartQueue.push({ variantId, quantity, btn });
  if (!processingQueue) processQueue();
}

function disableAllButtons() {
  document.querySelectorAll('button[name="add"]').forEach(b => {
    b.disabled = true;
    b.classList.add('is-temp-disabled');
  });
}

function enableAllButtons() {
  document.querySelectorAll('button[name="add"]').forEach(b => {
    b.disabled = false;
    b.classList.remove('is-temp-disabled');
  });
}

// ------------------------------
// MAIN QUEUE PROCESSOR
// ------------------------------
async function processQueue() {
  if (processingQueue) return;
  processingQueue = true;

  while (cartQueue.length > 0) {
    const { variantId, quantity, btn } = cartQueue.shift();

    const textEl = btn.querySelector('span') || btn;
    const originalText = textEl.textContent;

    disableAllButtons();
    textEl.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      const contentType = res.headers.get('content-type') || '';

      // ------------------------------
      // 429 RATE LIMIT (IMMEDIATE STOP)
      // ------------------------------
      if (res.status === 429) {
        console.warn('429 detected — stopping immediately');

        cartQueue = [];
        processingQueue = false;

        enableAllButtons();
        textEl.textContent = originalText;

        alert('Security check detected. Page will refresh.');

        window.location.href = window.location.href.split('?')[0];
        return;
      }

      // ------------------------------
      // CLOUDFLARE BLOCK
      // ------------------------------
      if (contentType.includes('text/html')) {
        console.warn('Cloudflare challenge detected — stopping');

        cartQueue = [];
        processingQueue = false;

        enableAllButtons();
        textEl.textContent = originalText;

        alert('Security check detected. Page will refresh.');

        window.location.href = window.location.href.split('?')[0];
        return;
      }

      if (!res.ok) throw new Error(`Add failed: ${res.status}`);

      await res.json();

      // ------------------------------
      // SUCCESS STATE (LONGER FEEDBACK)
      // ------------------------------
      textEl.textContent = 'Added';

      await delay(2000); // slower UX lock

      await refreshCartBubble();

    } catch (err) {
      console.error(err);

      textEl.textContent = 'Error';
      await delay(1000);
    }

    enableAllButtons();
    textEl.textContent = originalText;

    await delay(300);
  }

  processingQueue = false;
}

// ------------------------------
// CART BUBBLE UPDATE
// ------------------------------
async function refreshCartBubble() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const count = cart.item_count;

    bubble.innerHTML = count > 0
      ? `
        <span aria-hidden="true">${count}</span>
        <span class="visually-hidden">${count} items</span>
      `
      : '';

    bubble.style.display = 'block';

  } catch (err) {
    console.error('Cart refresh failed:', err);
  }
}
*/

/*
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('button[name="add"]');
  if (!btn) return;

  const productForm = btn.closest('product-form');
  if (!productForm) return;

  const form = productForm.querySelector('form');
  if (!form) return;

  const variantId = form.querySelector('input[name="id"]')?.value;
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || '1', 10);

  if (!variantId) return;

  e.preventDefault();

  const textEl = btn.querySelector('span') || btn;
  const originalText = textEl.textContent;

  // Disable all add buttons
  const allButtons = document.querySelectorAll('button[name="add"]');
  allButtons.forEach(b => b.disabled = true);

  try {
    textEl.textContent = 'Adding…';

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    // --------------------
    // 429 HANDLING
    // --------------------
    if (res.status === 429) {
      alert('You are adding items too quickly. Page will refresh.');
      window.location.href = window.location.href.split('?')[0];
      return;
    }

    if (!res.ok) throw new Error('Add failed');

    await res.json();

    textEl.textContent = 'Added';

    // update cart bubble immediately
    await refreshCartBubble();

    // keep "Added" visible for longer (e.g., 2s)
    await new Promise(r => setTimeout(r, 2000));

  } catch (err) {
    console.error(err);
    textEl.textContent = 'Error';
    await new Promise(r => setTimeout(r, 800));
  } finally {
    // Restore buttons & original text
    allButtons.forEach(b => b.disabled = false);
    textEl.textContent = originalText;
  }
});

async function refreshCartBubble() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const count = cart.item_count;

    bubble.innerHTML = count > 0
      ? `
        <span aria-hidden="true">${count}</span>
        <span class="visually-hidden">${count} items</span>
      `
      : '';

    bubble.style.display = 'block';

  } catch (err) {
    console.error('Cart bubble update failed:', err);
  }
}
*/

var addSelectedBtn = document.querySelector('.button--add-selected');

if ( addSelectedBtn ) {

  addSelectedBtn.addEventListener('click', async () => {

    const selectedItems = new Map();

    // 1️⃣ Loop through all quick-selection checkboxes
    document.querySelectorAll('.quick-selection .variant-input:checked').forEach(checkbox => {
      const variantId = checkbox.value;

      // Find the closest product card
      const productCard = checkbox.closest('.card');

      if (!productCard) return;

      // Get the quantity input inside the product card
      const quantityInput = productCard.querySelector('.quantity__input');
      const quantity = parseInt(quantityInput?.value || '1', 10);

      // Add to map
      selectedItems.set(variantId, quantity);
    });

    if (selectedItems.size === 0) {
      alert('Please select at least one item.');
      return;
    }

    // Disable button while processing
    const button = addSelectedBtn;
    const originalText = button.querySelector('.label').textContent;
    button.disabled = true;
    button.querySelector('.label').textContent = 'Adding...';

    try {
      // 2️⃣ Fetch current cart to merge quantities
      const cart = await fetch('/cart.js').then(r => r.json());

      const updates = {};

      // Merge existing cart items
      cart.items.forEach(item => {
        updates[item.id] = item.quantity;
      });

      // Merge selected items
      selectedItems.forEach((qty, id) => {
        updates[id] = (updates[id] || 0) + qty;
      });

      // 3️⃣ Send single update request
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (!res.ok) throw new Error('Failed to add items');

      // 4️⃣ Refresh cart bubble
      if (typeof refreshCartBubble === 'function') {
        await refreshCartBubble();
      }

      // Feedback
      button.querySelector('.label').textContent = 'Added';
      await new Promise(r => setTimeout(r, 2000));

    } catch (err) {
      console.error(err);
      button.textContent = 'Error';
      await new Promise(r => setTimeout(r, 1000));
    } finally {
      button.querySelector('.label').textContent = originalText;
      document.querySelector('.button--add-selected .count').textContent = 0;
      button.disabled = false;

      // Optionally clear checkboxes and qty after adding
      document.querySelectorAll('.quick-selection .variant-input:checked').forEach(c => c.checked = false);
      document.querySelectorAll('.quantity__input').forEach(e => e.value = 1);
    }

  });

  async function refreshCartBubble() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());

      const bubble = document.querySelector('.cart-count-bubble');
      if (!bubble) return;

      const count = cart.item_count;

      bubble.innerHTML = count > 0
        ? `
          <span aria-hidden="true">${count}</span>
          <span class="visually-hidden">${count} items</span>
        `
        : '';

      bubble.style.display = 'block';

    } catch (err) {
      console.error('Cart bubble update failed:', err);
    }
  }

  /*
  // Grab the button
  const unselectAllBtn = document.querySelector('.button--unselect-all');

  // Function to update button visibility
  function updateUnselectAllButton() {
    // Check if any checkboxes are selected
    const anySelected = document.querySelectorAll('.quick-selection .variant-input:checked').length;

    // Show/hide button
    unselectAllBtn.style.display = anySelected > 0 ? 'inline-block' : 'none';
  }

  // Initial check
  updateUnselectAllButton();

  // Listen for checkbox changes
  document.addEventListener('change', (e) => {
    const checkbox = e.target.closest('.variant-input');
    if (!checkbox) return;

    updateUnselectAllButton();
  });

  // Handle click to unselect all
  unselectAllBtn.addEventListener('click', () => {
    document.querySelectorAll('.quick-selection .variant-input:checked').forEach(c => c.checked = false);
    document.querySelectorAll('.quantity__input').forEach(e => e.value = 1);
    updateUnselectAllButton();
  });
  */

  function updateSelectedCount() {
    const selectedItems = document.querySelectorAll(
      '.quick-selection .variant-input:checked'
    );

    const totalQty = [...selectedItems].reduce((total, item) => {
      const card = item.closest('.card-wrapper');

      if (!card) return total;

      const qty = parseInt(
        card.querySelector('.quantity__input')?.value || '1',
        10
      );

      return total + qty;
    }, 0);

    document.querySelector('.button--add-selected .count').textContent = totalQty;
  }

  updateSelectedCount();
  document.addEventListener('change', (e) => {
    if (
      e.target.matches('.variant-input')
    ) {
      updateSelectedCount();
    }
  });
  ['change', 'input'].forEach(eventType => {
    document.addEventListener(eventType, (e) => {
      if (e.target.matches('.quantity__input')) {
        updateSelectedCount();
      }
    });
  });


  const productGrid = document.querySelector('#ProductGridContainer');

  if (productGrid) {
    const observer = new MutationObserver(() => {
      document.querySelector('.button--add-selected .count').textContent = '0';
    });

    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }

}



